module.exports = __webpack_public_path__ + "img/xp4_fd.228e7495.jpg";